import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Funzione per estrarre la lingua dalla URL
const getLanguageFromUrl = () => {
  const path = window.location.pathname;
  const lang = path.split('/')[1]; // Assumendo che la lingua sia il primo segmento della URL
  return lang;
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      es: {
        translation: {
          landing: {
            title: 'Juega con Loquis ahora y pon a prueba tu conocimiento',
          },
          tutorial: {
            questions: 'Preguntas',
            'ans-opt': 'Respuestas Posibles',
            time: 'Segundos para Responder',
            'errors-opt': 'Errores Posibles',
            play: 'jugar ahora',
          },
          summary: {
            'keep-playing': 'Sigue jugando',
            'play-now': 'Juega ahora',
            showdown: 'Respuestas correctas de',
            challenge:
              'Envía un correo electrónico a un amigo al que quieras desafiar, él/ella recibirá una invitación para jugar e intentar superar tu resultado.',
            'submit-name': 'Escribe el nombre',
            'submit-email': 'Escribe el correo electrónico',
            'email-sent': '¡Correo enviado!',
            'email-error': 'Error al enviar, contacta al administrador de la aplicación',
            'send-invitation': 'ENVIAR INVITACIÓN',
            close: 'CERRAR',
            'chl-friend': 'DESAFÍA A UN AMIGO',
            download: 'Descarga Loquis desde la Tienda ahora:',
            share: 'COMPARTIR',
            'share-fb': 'COMPARTIR',
            'play-more': 'Juega de nuevo',
            'go-back': 'VOLVER',
            'url-copied': 'URL copiada al portapapeles',
            'copy-url': 'COPIAR URL AL PORTAPAPELES',
          },
          game: {
            advertising: 'Publicidad - Haz clic arriba',
            errors: '§dE§ Errores en §tE§',
            'corr-answ': 'Respuestas correctas:',
            'ok-answ': '¡Buen trabajo! ¡Lo lograste!',
            'ko-answ': 'Lo siento, respuesta incorrecta',
            'go-summ': 'Ir al resumen',
            'go-on': 'Continuar',
            timeout: 'Se acabó el tiempo',
            continue: 'Continuar...',
            'all-quest-done': '¡Has respondido a todas las preguntas!',
            end: 'Terminar ahora',
          },
          header: {
            download: 'DESCARGAR LOQUIS',
            it: 'italiano',
            en: 'inglés',
            es: 'español',
            'choose-lng': 'idioma',
          },
        },
      },
      en: {
        translation: {
          landing: {
            title: 'Play with Loquis now and test your knowledge',
          },
          tutorial: {
            questions: 'Questions',
            'ans-opt': 'Possible Answers',
            time: 'Seconds to Answer',
            'errors-opt': 'Possible Errors',
            play: 'play now',
          },
          summary: {
            'keep-playing': 'Keep playing',
            'play-now': 'Play now',
            showdown: 'Correct answers on',
            challenge:
              'Send an email to a friend you want to challenge, he/she will receive an invitation to play and try to beat your result.',
            'submit-name': 'Write name',
            'submit-email': 'Write email',
            'email-sent': 'Email sent!',
            'email-error': 'Error sending, contact app administrator',
            'send-invitation': 'SEND INVITE',
            close: 'CLOSE',
            'chl-friend': 'CHALLENGE A FRIEND',
            download: 'Download Loquis from the Store now:',
            share: 'SHARE',
            'share-fb': 'SHARE',
            'play-more': 'Play more',
            'go-back': 'GO BACK',
            'url-copied': 'URL copied to clipboard',
            'copy-url': 'COPY URL TO CLIPBOARD',
            dialog: {
              text: '<p class="mb-2">Here is your 10% discount code, which you can use at our bars and restaurants with your <a class="txtUnderline" href="https://www.myautogrill.it/" target="_blank">My Autogrill</a>:<br><span class="txtColorOrange">LOQ26MA</span></p><p class="mb-2 fontSize70 fontWeight100">The code can be used only once and is valid for 30 days after being redeemed in the “REDEEM CODE” section of the My Autogrill app.<br>Discount valid until 12/31/2026. Promotion cannot be combined with other ongoing offers.</p>',
            },
          },
          game: {
            advertising: 'Advertising - Click above',
            errors: '§dE§ Errors on §tE§',
            'corr-answ': 'Correct answers:',
            'ok-answ': 'Good job! You did it!',
            'ko-answ': 'Sorry, wrong answer',
            'go-summ': 'Go to summary',
            'go-on': 'Go on',
            timeout: 'Timeout',
            continue: 'Continue...',
            'all-quest-done': 'You just answered to all questions!',
            end: 'End now',
          },
          header: {
            download: 'DOWNLOAD LOQUIS',
            it: 'italian',
            en: 'english',
            es: 'spanish',
            'choose-lng': 'language',
          },
        },
      },
      it: {
        translation: {
          landing: {
            title: 'Scegli con quale argomento giocare!',
          },
          tutorial: {
            questions: 'Domande',
            'ans-opt': 'Opzioni di Risposta',
            time: 'Secondi a Disposizione',
            'errors-opt': 'Possibilità di Errore',
            play: 'gioca ora',
          },
          summary: {
            'keep-playing': 'Gioca di nuovo',
            'play-now': 'Gioca',
            showdown: 'Rispost§vocal§ esatt§vocal§ su',
            challenge:
              'Inserisci la email di un amico che vuoi sfidare, riceverà un invito a giocare e a provare a superare il tuo risultato.',
            'submit-name': 'Inserisci il tuo nome',
            'submit-email': "Inserisci l'email",
            'email-sent': 'Email inviata!',
            'email-error': "Errore in fase di invio, contattare l'amministratore dell'app",
            'send-invitation': 'INVIA INVITO',
            close: 'CHIUDI',
            'chl-friend': 'SFIDA UN AMICO',
            download: 'Scarica ora Loquis dallo Store:',
            share: 'CONDIVIDI',
            'share-fb': 'CONDIVIDI',
            'play-more': 'GIOCA ANCORA',
            'go-back': 'INDIETRO',
            'url-copied': 'URL COPIATA NEGLI APPUNTI!',
            'copy-url': 'COPIA LA URL',
            dialog: {
              text: '<p class="mb-2">Ecco il tuo codice sconto del 10% che puoi utilizzare nei nostri bar e ristoranti con la tua <a class="txtUnderline" href="https://www.myautogrill.it/" target="_blank">My Autogrill</a>:<br><span class="txtColorOrange">LOQ26MA</span></p><p class="mb-2 fontSize70 fontWeight100">Il codice è utilizzabile una volta sola e ha validità 30 giorni una volta riscattato nella sezione “RISCATTA CODICE” dell’app My Autogrill.<br>Sconto valido fino al 31/12/2026. Promozione non cumulabile con altre iniziative in corso.</p>',
            },
          },
          game: {
            advertising: 'Advertising - Clicca qui sopra',
            errors: '§dE§ Error§vocal§ su §tE§',
            'corr-answ': 'Risposte esatte:',
            'ok-answ': 'COMPLIMENTI HAI INDOVINATO!',
            'ko-answ': ' HAI SBAGLIATO!',
            'go-summ': 'vai al riepilogo',
            'go-on': 'prosegui',
            timeout: 'Tempo scaduto',
            continue: 'Continua...',
            'all-quest-done': 'Hai risposto a tutte le domande!',
            end: 'Termina ora',
          },
          header: {
            'choose-lng': 'lingua',
            download: 'SCARICA LOQUIS',
            it: 'italiano',
            en: 'inglese',
            es: 'spagnolo',
          },
        },
      },
    },
    // lng: navigator.language.split('-')[0], // if you're using a language detector, do not define the lng option
    lng: getLanguageFromUrl(),
    supportedLngs: ['it', 'en', 'es'],
    fallbackLng: 'it',

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

export default i18n;
